import { Button, ButtonVariant, Icon, Intent, Tag , Popover as ElPopover, Position, HandleInteractionKind} from '@blueprintjs/core'
import { __ } from '@libs/utilities' 
import IScalarForm from '../interface/IScalarForm'
import Scalar from './Scalar'

const Popover = ( props: IScalarForm ): JSX.Element => {
    return <Scalar 
        { ...props } 
        enabledForm={<PopoverEnabled {...props} />}
        desabledForm={<PopoverDisabled {...props} />}
    /> 
}  

export default Popover

export const PopoverEnabled = (props: IScalarForm) : JSX.Element =>  {
    const value = props.value || props.default
    const _value = typeof ( value ) === "object" 
        ? 
        (value)
        : 
        {
            _id: (value),
            title: (value),
            img: props.values?.find( v => v._id === value )?.img,
            height: props.height || 45,
            description: props.values?.find( v => v._id === value )?.description,
        } 
    const onClick = ( i:number) => {
        const v = [ ...props.values || [] ].filter((val, n) => n === i)[0]
        if( props.onChange && v ) {
            props.onChange(
                v._id ? v._id : v, 
                props.field, 
                ""
            )
        }
    }
    const cards: any = props.values?.map((value: any, i) => {
        const checked = Array.isArray( _value )
            ?
            !!_value.filter( v => v === value._id ).length
            :
            value._id === _value._id
        return <Button
            key={i}
            role="button"
            className="btn-stretch p-0"
            onClick={( ) => onClick( i )}
            data-v={ value._id }
            fill
            variant={ ButtonVariant.MINIMAL }
            style={{width: value.width || props.width || 100}}
        >
            <div className={ `w-100 flex-centered flex-column ${checked ? "bg-contrast-opacity " : ""}` } style={{ padding: value.padding || 10 }}>
                <img
                    src={ value.img }
                    alt={ "" }
                    className="scalar-imgage-radio-img mb-1 "
                    style={{
                        height: (parseInt( ( value.height || props.height || 110).toString() ) ) - 20,
                        top: 0,
                        opacity: checked
                            ? 
                            value.icon_opacity
                                ? 
                                value.icon_opacity
                                : 
                                1
                            : 
                            0.33,
                    }}
                />
                <div className="title smaller text-uppercase" style={{...props.style, maxWidth: "100%" }}>
                    { __(value.title) }
                </div>
                <div 
                    className="scalar-imgage-radio-description" 
                    style={{ maxWidth: "100%" }}
                >
                    { __(value.description) }
                </div> 
            </div>
        </Button>
    })
    const i = !!Array.isArray(props.values) ?  props.values.findIndex((card: any) => card._id === ( typeof _value === "string" ? _value : _value._id )) :-1


    return <ElPopover
        position={ Position.LEFT }
        interactionKind={"click"}
        className='w-100'
        content={
            <div className='scalar-popover-content sub-menu-container overflow-y-auto'>
                { cards }
            </div>
        }
    >
        <div className=''>
            <Button
                role="button"
                className="btn-stretch"
                data-v={ _value._id }
                fill
                variant={ ButtonVariant.MINIMAL }
            >
                <div className="w-100 flex-centered flex-column position-relative">
                    <img
                        src={ _value.img }
                        alt={ "" }
                        className="scalar-imgage-radio-img mb-1 "
                        style={{
                            height: (parseInt( (props.height || 50).toString() )) - 20,
                            top: 0
                        }}
                    />
                    <div className="title" style={{...props.style, maxWidth: "100%" }}>
                        { __(_value.title) }
                    </div>
                    <div 
                        className="scalar-imgage-radio-description" 
                        style={{ maxWidth: "100%" }}
                    >
                        { __(_value.description) }
                    </div>                    
                    <div className="h-100 d-flex position-absolute top left m-2">
                        <Icon icon="caret-left" className='my-auto' />
                    </div>
                    <div className="h-100 d-flex position-absolute top right m-2">
                        <Icon icon="caret-right" className='my-auto' />
                    </div>
                </div>
            </Button> 
        </div>
    </ElPopover>
}

export const PopoverDisabled = (props: IScalarForm) : JSX.Element => {
     const checkedValue = props.values?.filter( v => v._id === props.value )[0]
        const _value = typeof (props.value || props.default ) === "object" 
            ? 
            (props.value || props.default )
            : 
            {
                _id: (props.value || props.default ),
                title: (props.value || props.default ),
                img: "",
                height: 45
            } 
        return checkedValue
            ?
            <div>
                <img
                    src={checkedValue.img}
                    alt={_value.title}
                    className="scalar-imgage-radio-img"
                    style={{
                        height: checkedValue.height,
                        top: 0 
                    }}
                />
                <div>{ _value.title }</div>
            </div>
            :
            <Tag>
                { _value.title }
            </Tag>
}